<div class="orders-container">
  <h2 i18n>My Orders</h2>
  <ng-container>
    <div class="card orders-card">
      <p i18n  class="card-header mat-card-header">ORDER HISTORY</p>
      <div class="content">
        <div class="table-container">
          <div class="mat-elevation-z8 order-table">
            <div class="column-container title-column-container">
              <th class="title-column" i18n>Date</th>
              <th class="title-column" i18n>#</th>
              <th class="title-column" i18n>Total</th>
              <th class="title-column" i18n>Status</th>
              <th class="title-column" i18n></th>
            </div>
            <div *ngFor="let item of orders">
              <div class="column-container">
                <th>{{item.created_date | date:'yyyy-MM-dd HH:mm'}}</th>
                <th>{{item.id}}</th>
                <th><app-currency-converter [data]="{price:item.totalPrice, country: null}"></app-currency-converter></th>
                <th i18n *ngIf="item.status_id == 0">Placed</th>
                <th i18n *ngIf="item.status_id == 1">Confirmed</th>
                <th i18n *ngIf="item.status_id == 2">In Progress</th>
                <th i18n *ngIf="item.status_id == 3">Shipped</th>
                <th i18n *ngIf="item.status_id == 4">Deliverd</th>
                <th class="status-container">
                  <p i18n  class="view-detail" (click)="item.displayDetails = !item.displayDetails">View Details
                    <mat-icon class="arrow-icon">keyboard_arrow_right</mat-icon>
                  </p>
                </th>

              </div>
              <div *ngIf="item.displayDetails == true" class="details-container">
                <div class="left">
                  <div class="status-bar-container">
                    <div class="status-row">
                      <div class="status-ball" [ngStyle]="item.status_id >=0?{'background-color':'#B6C1B1' } : {}">
                      </div>
                      <div class="status-ball" [ngStyle]="item.status_id >= 1?{'background-color':'#B6C1B1' } : {}">
                      </div>
                      <div class="status-ball" [ngStyle]="item.status_id >= 2?{'background-color':'#B6C1B1' } : {}">
                      </div>
                      <div class="status-ball" [ngStyle]="item.status_id >= 3?{'background-color':'#B6C1B1' } : {}">
                      </div>
                      <div class="status-ball" [ngStyle]="item.status_id >= 4?{'background-color':'#B6C1B1' } : {}">
                      </div>
                    </div>
                    <div class="status-row">
                      <div class="status-line" [ngStyle]="item.status_id >= 0?{'background-color':'#B6C1B1' } : {}">
                      </div>
                      <div class="status-line" [ngStyle]="item.status_id >= 1?{'background-color':'#B6C1B1' } : {}">
                      </div>
                      <div class="status-line" [ngStyle]="item.status_id >= 2?{'background-color':'#B6C1B1' } : {}">
                      </div>
                      <div class="status-line" [ngStyle]="item.status_id >= 3?{'background-color':'#B6C1B1' } : {}">
                      </div>
                    </div>
                    <div class="status-row">
                      <p i18n >Placed</p>
                      <p i18n >Confirmed</p>
                      <p i18n >In Progress</p>
                      <p i18n >Shipping</p>
                      <p i18n >Delivered</p>
                    </div>
                  </div>
                  <div class="customer-details-container">
                    <p i18n  class="title">Customer details</p>
                    <div class="customer-details">
                      <div class="customer-contact-info">
                        <div class="">
                          <div class="item">
                            <label i18n for="name">Name: </label>
                            <p i18n id="name">{{ item.first_name ? ""+item.first_name+" "+item.last_name+"" : ""+user.firstname+" "+user.lastname+""}}</p>
                          </div>
                          <div class="item">
                            <label i18n for="email">Email: </label>
                            <p i18n id="email">{{ item.email ? item.email : user.email}}</p>
                          </div>
                          <div class="item">
                            <label i18n for="phone">Phone: </label>
                            <p i18n id="phone">{{ item.phone_nr ? item.phone_nr : user.phone}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="customer-adress-info">
                        <div class="address">
                          <label i18n for="address">Address: </label>
                          <p i18n id="address" *ngIf="item.articles[0].article_id != 3" >Shipping address: {{item.shipping_address}}</p>
                          <p i18n id="address">Billing address: {{item.billing_address}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="message-container" *ngIf="item.support_message">
                    <label i18n for="message">Order message: </label>
                    <p i18n id="message">{{item.support_message}}</p>
                  </div>
                </div>
                <div class="right">
                  <div class="order-details">
                    <p i18n  class="title">Order details</p>
                    <div class="article-details">
                      <div class="row">
                        <label i18n class="product">Products</label>
                        <label i18n class="attribute">Attributes</label>
                        <label i18n class="collumn">Quantity</label>
                      </div>
                      <div class="row">
                        <div i18n class="product"> {{item.articles[0].title}}</div>
                        <div class="attribute">
                          <p i18n *ngFor="let attribute of item.articles[0].attributes"> {{attribute.attribute_culture}}:
                            {{attribute.attribute_value_culture}}</p>
                        </div>
                        <p i18n  class="collumn">{{item.articles[0].quantity}}</p>
                      </div>
                      <div class="row" *ngIf="item.discount != undefined">
                        <div i18n class="product"> {{item.discount.code}}</div>
                        <div class="attribute">
                          {{item.discount.procentage * 100}}%
                        </div>
                        <p i18n  class="collumn">- <app-currency-converter [data]="{price:(item.product_price/(1 - item.discount.procentage) - item.product_price) * item.articles[0].quantity, country: null}"></app-currency-converter></p>
                      </div>
                      <div class="prices">
                        <div *ngIf="item.discount != undefined">
                          <div class="price">
                            <label i18n>Product: </label>
                            <p i18n id="price">{{item.articles[0].quantity}} x <app-currency-converter [data]="{price:item.product_price/(1 - item.discount.procentage) * item.articles[0].quantity , country: null}"></app-currency-converter></p>
                          </div>
                          <div class="price">
                            <label i18n>Discount: </label>
                            <p i18n id="price">- <app-currency-converter [data]="{price:(item.product_price/(1 - item.discount.procentage) - item.product_price)* item.articles[0].quantity, country: null}"></app-currency-converter></p>
                          </div>
                        </div>
                        <div *ngIf="item.discount === undefined">
                          <div class="price">
                            <label i18n>Product: </label>
                            <p i18n id="price">{{item.articles[0].quantity}} x <app-currency-converter [data]="{price:item.product_price , country: null}"></app-currency-converter></p>
                          </div>
                        </div>

                        <div class="price">
                          <label i18n>Shipping: </label>
                          <p i18n id="price"><app-currency-converter [data]="{price:item.shipping_price, country: null}"></app-currency-converter></p>
                        </div>
                        <div class="price">
                          <label i18n>VAT: </label>
                          <p i18n id="price"><app-currency-converter [data]="{price:item.VAT, country: null}"></app-currency-converter></p>
                        </div>
                        <div class="price">
                          <label i18n>Total: </label>
                          <label id="price"><app-currency-converter [data]="{price:item.totalPrice, country: null}"></app-currency-converter></label>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <label i18n>Payment method:</label>
                      <p i18n id="name">{{item.payment}}</p>
                    </div>
                    <div class="item" *ngIf="item.articles[0].article_id != 3">
                      <label i18n>Shipping time:</label>
                      <p i18n id="name">{{item.shipment_days}} days</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p i18n  class="no-order" *ngIf="orders.length == 0">No orders yet</p>
      </div>
    </div>
  </ng-container>
</div>